<div class="content-lp-interview-section">
  <!-- カルーセルセクション（記事詳細ページへの誘導） -->
  <div class="carousel-section mb-4" aria-label="利用者様のインタビュー記事">
    <!-- PC用カルーセル -->
    <div *ngIf="!isMobile" class="splide splide-pc">
      <div class="splide__track">
        <ul class="splide__list">
          <li *ngFor="let article of interviewArticles" class="splide__slide">
            <a
              [href]="article.link"
              target="_blank"
              class="block bg-white rounded-3xl hover:opacity-70 transition-opacity cursor-pointer h-full relative
                     before:content-[''] before:absolute before:bg-no-repeat before:bg-contain before:h-[15px] md:before:h-[22px] before:left-8 before:bg-[url('/assets/images/lp/double-quote-start.svg')] before:bg-left before:-top-[7px] md:before:-top-[10px] before:aspect-[37/24] before:z-10"
            >
              <div class="flex flex-row items-stretch h-full rounded-3xl">
                <!-- コンテンツ（左側） -->
                <div class="flex-[6] p-8 pr-0 flex flex-col justify-between">
                  <div>
                    <h3 class="text-[22px] font-bold mb-4">{{ article.title }}</h3>
                    <div class="text-base mb-3">
                      <div>{{ article.schoolName }}</div>
                      <div>{{ article.name }}</div>
                    </div>
                    <p class="text-[11px] text-sub leading-relaxed">{{ article.description }}</p>
                  </div>
                  <div class="mt-4">
                    <span class="inline-flex items-center text-primary font-medium text-sm">
                      記事を読む
                      <svg class="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </span>
                  </div>
                </div>
                <!-- サムネイル（右側） -->
                <div class="flex-[6] p-6 flex items-start">
                  <div class="w-full aspect-[16/10] overflow-hidden rounded-2xl">
                    <img
                      [src]="article.thumbnailUrl"
                      [alt]="article.title"
                      [style.object-position]="article.objectPosition || 'center center'"
                      class="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- スマホ用カルーセル -->
    <div *ngIf="isMobile" class="splide splide-mobile">
      <div class="splide__track">
        <ul class="splide__list">
          <li *ngFor="let article of interviewArticles" class="splide__slide">
            <div class="bg-white rounded-3xl h-full">
              <div class="flex flex-col h-full overflow-hidden rounded-3xl">
                <!-- サムネイル（上側） -->
                <div class="w-full aspect-[16/10] overflow-hidden">
                  <img
                    [src]="article.thumbnailUrl"
                    [alt]="article.title"
                    [style.object-position]="article.objectPosition || 'center center'"
                    class="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <!-- コンテンツ（下側） -->
                <div
                  class="p-6 flex flex-col flex-1 relative
                           before:content-[''] before:absolute before:bg-no-repeat before:bg-contain before:h-[15px] before:left-6 before:bg-[url('/assets/images/lp/double-quote-start.svg')] before:bg-left before:-top-[10px] before:aspect-[37/24] before:z-10"
                >
                  <div class="text-[0.825rem] mb-2">
                    <div>{{ article.schoolName }}</div>
                    <div>{{ article.name }}</div>
                  </div>
                  <h3 class="text-lg font-bold mb-3">{{ article.title }}</h3>
                  <p class="text-[11px] text-sub leading-relaxed mb-4 flex-1">{{ article.description }}</p>
                  <div>
                    <a
                      [href]="article.link"
                      target="_blank"
                      class="inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-700 transition-colors text-md"
                    >
                      記事を読む
                      <svg class="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <app-wrapper size="md">
    <div class="comment-cards-section">
      <h2 class="text-center text-lg md:text-xl mb-12 font-bold">
        他にも、多くの先生方から<br class="md:hidden" />ご好評いただいています！
      </h2>
      <div class="grid grid-cols-2 gap-x-4 gap-y-5 sm:gap-x-5 sm:gap-y-8 sm:grid-cols-2 md:grid-cols-3 md:gap-x-8 md:gap-y-10 mb-6">
        <div
          *ngFor="let voice of teacherVoices"
          class="bg-white rounded-3xl p-4 sm:p-5 md:p-6 relative flex flex-col
               before:content-[''] before:absolute before:bg-no-repeat before:bg-contain before:h-[15px] md:before:h-[22px] before:left-6 before:bg-[url('/assets/images/lp/double-quote-start.svg')] before:bg-left before:-top-[7px] md:before:-top-[10px] before:aspect-[37/24]"
        >
          <p class="my-2 flex-1 tracking-wider font-bold text-sm md:text-base leading-[1.6]">
            {{ voice.message }}
          </p>
          <div class="mt-4 flex items-center">
            <div class="w-[36px] min-w-[36px] h-[36px] rounded-full overflow-hidden">
              <img [src]="voice.thumbnailUrl" [alt]="voice.subject" class="w-full h-full object-cover" loading="lazy" />
            </div>
            <div class="flex-grow ml-4 text-sm md:text-base">{{ voice.teacherName }}</div>
          </div>
        </div>
      </div>
    </div>
  </app-wrapper>
</div>
